"use strict";

var cov_gmqbmzt3i = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/authentication/Authentication.context.js";
  var hash = "550cff87e2f01bc211b88cb446aa1b7b2893318b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/authentication/Authentication.context.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 37
        },
        end: {
          line: 6,
          column: 58
        }
      },
      "1": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 21,
          column: 4
        }
      },
      "2": {
        start: {
          line: 22,
          column: 18
        },
        end: {
          line: 27,
          column: 3
        }
      },
      "3": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 33,
          column: 4
        }
      },
      "4": {
        start: {
          line: 36,
          column: 0
        },
        end: {
          line: 64,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "AuthenticationContextProvider",
        decl: {
          start: {
            line: 8,
            column: 16
          },
          end: {
            line: 8,
            column: 45
          }
        },
        loc: {
          start: {
            line: 16,
            column: 3
          },
          end: {
            line: 34,
            column: 1
          }
        },
        line: 16
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "550cff87e2f01bc211b88cb446aa1b7b2893318b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthenticationContextProvider = AuthenticationContextProvider;
exports.AuthenticationContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require(".");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AuthenticationContext = (cov_gmqbmzt3i.s[0]++, _react.default.createContext());
exports.AuthenticationContext = AuthenticationContext;

function AuthenticationContextProvider(_ref) {
  var _config = _ref.config,
      messages = _ref.messages,
      authentication = _ref.authentication,
      onAuthentication = _ref.onAuthentication,
      loadAuthentication = _ref.loadAuthentication,
      saveAuthentication = _ref.saveAuthentication,
      children = _ref.children;
  cov_gmqbmzt3i.f[0]++;

  var _ref2 = (cov_gmqbmzt3i.s[1]++, (0, _.useAuthentication)({
    authentication: authentication,
    onAuthentication: onAuthentication,
    config: _config,
    messages: messages,
    loadAuthentication: loadAuthentication,
    saveAuthentication: saveAuthentication
  })),
      state = _ref2.state,
      actions = _ref2.actions,
      component = _ref2.component,
      config = _ref2.config;

  var context = (cov_gmqbmzt3i.s[2]++, {
    state: state,
    actions: actions,
    component: component,
    config: config
  });
  cov_gmqbmzt3i.s[3]++;
  return /*#__PURE__*/_react.default.createElement(AuthenticationContext.Provider, {
    value: context
  }, children);
}

;
cov_gmqbmzt3i.s[4]++;
AuthenticationContextProvider.propTypes = {
  /** Pass a previously returned authentication object to bypass login. */
  authentication: _propTypes.default.shape({
    user: _propTypes.default.object.isRequired,
    token: _propTypes.default.object.isRequired,
    config: _propTypes.default.object.isRequired,
    remember: _propTypes.default.bool
  }),

  /** Callback function to propogate the user/token used for API Authentication. */
  onAuthentication: _propTypes.default.func,

  /** Configuration to pass through to the Authentication component. */

  /** Override the default text and errors. Must override all or none. */
  messages: _propTypes.default.shape({
    actionText: _propTypes.default.string.isRequired,
    genericError: _propTypes.default.string.isRequired,
    usernameError: _propTypes.default.string.isRequired,
    passwordError: _propTypes.default.string.isRequired
  }),
  config: _propTypes.default.shape({
    /** The Gitea server to use when authenticating. */
    server: _propTypes.default.string.isRequired,

    /** The id of the token to create/retrieve that is used for the app. */
    tokenid: _propTypes.default.string.isRequired
  }),

  /** Callback function to persist authentication. */
  saveAuthentication: _propTypes.default.func,

  /** Callback function to retrieve persisted authentication. */
  loadAuthentication: _propTypes.default.func
};